import {
  ProcessingReceivingSource as SourceSchema,
  ProcessingReceivingTarget as TargetSchema,
} from "@redotech/redo-return-warehouse-processing-common/processing-receiving-source";

export const ProcessingReceivingSource = SourceSchema;
export type ProcessingReceivingSource = SourceSchema;
export const ProcessingReceivingTarget = TargetSchema;
export type ProcessingReceivingTarget = TargetSchema;
